module.exports = "https://coursera_assets.s3.amazonaws.com/images/19037a9a9ce4710bd1ab595f48565127.png";